export default __webpack_public_path__ + "static/Bg_react_dubai-f667cba62c1e317428354e036848e486.webp";